<!-- Mock-only template to reproduce the requested screen layout. -->
<div class="p-6 space-y-6">
  <!-- Top: Title and Actions -->
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-2xl font-bold text-sigecom-dark-gray">
        Gerenciar Rodadas e Confrontos
      </h1>
    </div>

    <div class="flex gap-2">
      <!-- <sigecom-button
        class="text-sigecom-info"
        title="GERAR CONFRONTOS DA RODADA"
        icon="shuffle"
        (buttonClicked)="generateClashFromRound()"
      ></sigecom-button> -->
      <sigecom-button
        [disabled]="drawDisabled"
        class="text-sigecom-info"
        title="GERAR TODOS OS CONFRONTOS"
        icon="shuffle"
        (buttonClicked)="generateAllClashs()"
      ></sigecom-button>
    </div>
  </div>
  <div class="w-full bg-white p-4 rounded-lg shadow-lg">
    <div
      class="flex flex-col text-sigecom-gray"
      *ngIf="simpleStepParametrization$ | async as info"
    >
      <b class="text-xl flex text-sigecom-info gap-4">
        {{ info.petTxNome }}
      </b>
      <div class="flex gap-2">
        <div class="flex gap-2 items-center">
          <b>Evento:</b>
          <p>{{ eventData?.eveTxNome }}</p>
          <div class="my-2 h-4 w-0.5 bg-sigecom-gray"></div>
        </div>
        <div class="flex gap-2 items-center">
          <b>Bloco:</b>
          <p>{{ parametrizationDto?.bloObjCompeticao?.bloTxNome }}</p>
          <div class="my-2 h-4 w-0.5 bg-sigecom-gray"></div>
        </div>
        <div class="flex gap-2 items-center">
          <b>Competição:</b>
          <p>{{ parametrizationDto?.comObjCompeticao?.comTxNome }}</p>
        </div>
      </div>
      <div class="flex gap-2">
        <div class="flex gap-2 items-center">
          <b>Formato da fase:</b>
          <p>{{ info.formatoInfo }}</p>
          <div class="my-2 h-4 w-0.5 bg-sigecom-gray"></div>
        </div>
        <div class="flex gap-2 items-center">
          <b>Categoria:</b>
          <p>{{ info.categoriaInfo }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabs for keys (CHAVE A..H) -->
  <div class="flex gap-2 items-center tabs-scroll py-2">
    <div
      *ngFor="let key of keys$ | async"
      class="px-4 flex gap-2 py-2 rounded-md border border-sigecom-gray shadow-md text-sigecom-info bg-white hover:bg-slate-50 text-nowrap"
    >
      <sigecom-radio-button
        name="keys"
        (selectedChange)="selectedKey?.next(key)"
        [value]="key"
        [selected]="selectedKey?.value"
        [label]="key.cheTxNome"
      />
    </div>
  </div>
  <div class="flex justify-between items-center px-4 text-sigecom-info">
    <div class="text-xl flex gap-4">
      <b
        >Rodada {{ rodadaCurrentIndex.value + 1 }} de
        {{ rodadaDtoList?.length }}</b
      >
      <div class="flex text-sigecom-info/50 gap-0.5">
        <fa-icon
          icon="chevron-left"
          (click)="changeRodadasPage('prev')"
          [ngClass]="{
            'text-sigecom-gray/30': rodadaCurrentIndex.value == 0,
            'hover:text-sigecom-info': rodadaCurrentIndex.value != 0,
          }"
        ></fa-icon>
        <fa-icon
          icon="chevron-right"
          (click)="changeRodadasPage('next')"
          [ngClass]="{
            'text-sigecom-gray/30':
              rodadaCurrentIndex.value + 1 == rodadaDtoList?.length,
            'hover:text-sigecom-info':
              rodadaCurrentIndex.value + 1 != rodadaDtoList?.length,
          }"
        ></fa-icon>
      </div>
    </div>
    <b class="text-xl flex gap-4">
      {{ petDescription }}
    </b>

    <sigecom-button
      title="TABELA DE JOGOS"
      icon="table"
      (buttonClicked)="openGamesTable()"
      class="text-sigecom-info"
    ></sigecom-button>
  </div>

  <!-- Main content: left participants, center confronts -->

  <div class="grid grid-cols-12 gap-6">
    <!-- Left: Participants list -->
    <div class="col-span-3 bg-white shadow-md rounded-lg p-4">
      <ng-container *ngIf="selectedKey?.value as key; else empty">
        <div class="flex items-center justify-between mb-4">
          <div>
            <h2 class="font-bold text-lg">
              Participantes da {{ key.cheTxNome }}
            </h2>
            <div class="text-sm text-sigecom-gray">
              {{ qtdTotalInc }} participantes
            </div>
          </div>
        </div>
        <div class="space-y-2">
          <ng-container
            *ngFor="let inc of getEnrollments(key.cheNrId); let i = index"
          >
            <div
              class="flex justify-start items-center gap-3 w-full bg-gray-100 p-3 rounded-md"
            >
              <div
                class="w-7 h-7 aspect-square rounded-full bg-sigecom-info text-white flex items-center justify-center font-bold"
              >
                <ng-container *ngIf="inc.ineBlCabecaChave; else number">
                  <fa-icon class="text-yellow-300" icon="key"></fa-icon>
                </ng-container>
                <ng-template #number>
                  {{ i + 1 }}
                </ng-template>
              </div>
              <div class="w-full flex gap-2">
                <span class="text-sigecom-gray">{{ inc.estTxNome }}</span>
              </div>
              <sigecom-radio-button
                name="inc"
                [value]="true"
                [selected]="participantToAdd.value?.ichNrId === inc.ichNrId"
                (selectedChange)="participantToAdd.next(inc)"
              />
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #empty>
        <div class="py-2 w-full text-center text-sigecom-danger">
          <b>Selecione ao menos uma chave </b>
        </div>
      </ng-template>
    </div>

    <!-- Center: Confrontos -->
    <form
      [formGroup]="embatesFa"
      class="col-span-9 text-center text-sigecom-gray bg-white shadow-md gap-2 flex flex-col rounded-lg p-4"
    >
      <div class="col-span-full items-center flex justify-between">
        <h2 class="font-bold ml-2 text-lg">
          Confrontos da Rodada {{ rodadaCurrentIndex.value + 1 }}
        </h2>
        <sigecom-button
          title="ADICIONAR CONFRONTO"
          type="info"
          outlined
          icon="plus"
          invertIconPos
          (buttonClicked)="createEmbate(rodadaDtoView?.rodNrId)"
        />
      </div>

      <ng-template #confrontosEmpty>
        <div
          class="col-span-full flex flex-col items-center justify-center gap-2 my-auto py-2 text-sigecom-outlined-gray"
        >
          <fa-icon icon="circle-info" class="text-2xl"></fa-icon>
          <span>Nenhum confronto definido</span>
        </div>
      </ng-template>

      <!-- Table Header -->
      <ng-container *ngIf="hasConfrontosNaRodadaAtual; else confrontosEmpty">
        <div
          class="col-span-full grid-cols-[repeat(15,minmax(0,1fr))] grid gap-1 items-center mt-2 text-center"
        >
          <div class="col-span-2">Mod.</div>
          <div class="col-span-2">Chave</div>
          <div class="col-span-5">Equipe A</div>
          <div class="col-start-11 col-span-5">Equipe B</div>
        </div>

        <div formArrayName="confrontos">
          <ng-container
            *ngFor="let item of confrontosFa.controls; let i = index"
          >
            <div
              *ngIf="showConfrontoForCurrentRodada(item)"
              [formGroupName]="i"
              class="col-span-full mb-1 grid-cols-[repeat(15,minmax(0,1fr))] gap-1 grid items-center text-center"
            >
              <div
                class="col-span-2 p-2 flex flex-col place-content-center h-full rounded-lg bg-gray-100 text-[1rem] text-sigecom-info text-center"
              >
                <span class="font-semibold">{{ getModalityAcronymByKey(item.controls.chaveEmbateSimplesDto.value) }}</span>
              </div>
              <div
                class="col-span-2 p-3 flex place-content-center h-full rounded-lg bg-gray-100"
              >
                <div
                  class="place-content-center"
                  *ngIf="keysMap$ | async as keysMap"
                >
                  {{ item.value.cheTxNome ?? (item.value.cheNrId ? keysMap[item.value.cheNrId] : '') }}
                </div>
              </div>
              <div
                class="col-span-5 text-sigecom-info flex items-center text-2xl font-medium p-3 rounded-lg bg-gray-100"
              >
                <p
                  class="text-center h-full hover:bg-gray-200/50 rounded-full w-full"
                  (click)="addParticipant('A', i)"
                >
                  {{
                    getIncDisplayName(
                      item.controls.inscricaoEmbateFormulario.value.at(0)
                    )
                  }}
                  <small class="block text-xs text-sigecom-gray font-normal">
                    {{ getParticipantKeyName(item.controls.inscricaoEmbateFormulario.value.at(0), item.value.cheTxNome) }}
                  </small>
                </p>
                <div
                  *ngIf="
                    item.controls.inscricaoEmbateFormulario.value.at(0)?.ichNrId
                  "
                  (click)="removeParticipant(i, 'A')"
                  class="aspect-square place-content-center text-sm px-2 rounded-full bg-white text-sigecom-danger"
                >
                  <fa-icon icon="trash" />
                </div>
              </div>
              <div class="col-span-1">X</div>
              <div
                class="col-span-5 flex place-content-center text-sigecom-info text-2xl font-medium p-3 rounded-lg bg-gray-100"
              >
                <p
                  class="text-center h-full hover:bg-gray-200/50 rounded-full w-full"
                  (click)="addParticipant('B', i)"
                >
                  {{
                    getIncDisplayName(
                      item.controls.inscricaoEmbateFormulario.value.at(1)
                    )
                  }}
                  <small class="block text-xs text-sigecom-gray font-normal">
                    {{ getParticipantKeyName(item.controls.inscricaoEmbateFormulario.value.at(1), item.value.cheTxNome) }}
                  </small>
                </p>
                <div
                  *ngIf="
                    item.controls.inscricaoEmbateFormulario.value.at(1)?.ichNrId
                  "
                  (click)="removeParticipant(i, 'B')"
                  class="aspect-square place-content-center text-sm px-2 rounded-full bg-white text-sigecom-danger"
                >
                  <fa-icon icon="trash" />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </form>
  </div>
</div>
<style>
  .tabs-scroll {
    overflow-x: auto;

    &::-webkit-scrollbar {
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #9d9d9e52;
      border-radius: 999px;
    }

    &:hover::-webkit-scrollbar-thumb {
      background: #d4d7e5;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #08135769;
    }
  }
</style>
